const insertIf = <T>(condition: unknown, ...elements: T[]) => {
  return Boolean(condition) ? elements : [];
};

export default insertIf;
